<template src="../../templates/form/fecondity-form.pug" lang="pug"></template>

<script>
import Modal from './Modal.vue'
import { mapActions, mapGetters } from 'vuex'
import { required, minLength, maxLength, minValue, maxValue, requiredIf, integer } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import { format } from 'date-fns'
import _filter from 'lodash/filter'

export default {
    name: 'FecondityForm',
    props: ['action', 'animal'],
    components: {
        Modal,
        Multiselect
    },
    data() {
        return {
            state: {
                calving: {
                    type: 'heifer',
                    abortion: null,
                    date: Math.trunc(Date.now() / 1000),
                    buckleNumber: ''
                },
                cull: {
                    tag: 'cull',
                    price: 0,
                    date: Math.trunc(Date.now() / 1000)
                },
                dried: {
                    date: Math.trunc(Date.now() / 1000)
                },
                hot: {
                    date: Math.trunc(Date.now() / 1000)
                },
                insemination: {
                    date: Math.trunc(Date.now() / 1000),
                    fromBull: null,
                    father: null,
                    artificialFatherName: ''
                },
                ultrasound: {
                    result: 'pregnant',
                    date: Math.trunc(Date.now() / 1000)
                }
            },
            typeList: ['calf', 'heifer'],
            tagList: ['cull', 'dead', 'sold'],
            abortionType: ['abortion', 'abortion-dead', 'stillbirth', 'stillbirth-dead', 'abortion-but'],
            ultrasoundResult: ['pregnant', 'empty', 'unknown']
        }
    },
    computed: {
        ...mapGetters(['filteredFarmAnimalsByType', 'selectedFarm', 'animals', 'isBuckleNumberAlreadyGiven']),
        _calvingDate: {
            get() {
                return format(new Date(this.state.calving.date * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.state.calving.date = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _cullDate: {
            get() {
                return format(new Date(this.state.cull.date * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.state.cull.date = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _driedDate: {
            get() {
                return format(new Date(this.state.dried.date * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.state.dried.date = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _hotDate: {
            get() {
                return format(new Date(this.state.hot.date * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.state.hot.date = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _inseminationDate: {
            get() {
                return format(new Date(this.state.insemination.date * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.state.insemination.date = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _ultrasoundDate: {
            get() {
                return format(new Date(this.state.ultrasound.date * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.state.ultrasound.date = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _deadDate: {
            get() {
                return format(new Date(this.state.dead.date * 1000), 'YYYY-MM-DD')
            },
            set(newVal) {
                this.state.dead.date = Math.trunc(new Date(newVal).getTime() / 1000)
            }
        },
        _father: {
            get() {
                return _filter(this.animals, { id: this.state.insemination.father })
            },
            set(newVal) {
                this.state.insemination.father = newVal.id
            }
        },
        isCalvingFormValid() {
            return !this.$v.state.calving.date.$invalid && !this.$v.state.calving.buckleNumber.$invalid
        },
        isCullFormValid() {
            return !this.$v.state.cull.date.$invalid
        },
        isDriedFormValid() {
            return !this.$v.state.dried.date.$invalid
        },
        isHotFormValid() {
            return !this.$v.state.hot.date.$invalid
        },
        isInseminationFormValid() {
            return !this.$v.state.insemination.date.$invalid
        },
        isUltrasoundFormValid() {
            return !this.$v.state.ultrasound.date.$invalid
        }
    },
    validations: {
        state: {
            calving: {
                date: {
                    required,
                    minValue(date) {
                        let lastStateDate = this.animal != null && this.animal.states[0] !== undefined ? this.animal.states[0].date : 0
                        return date > lastStateDate
                    },
                    maxValue: maxValue(Math.trunc(Date.now() / 1000) + (60*60))
                },
                buckleNumber: {
                    required: requiredIf(function() {return this.state.calving.type !== null}),
                    isUnique(value) {
                        if (value === '' || this.state.calving.abortion !== null) {
                            return true
                        }
                        let isAlreadyGiven = !this.isBuckleNumberAlreadyGiven(value)
                        return isAlreadyGiven
                    },
                    minLength: minLength(1),
                    maxLength: maxLength(15)
                }
            },
            cull: {
                date: {
                    required,
                    minValue(date) {
                        let lastStateDate = this.animal != null && this.animal.states[0] !== undefined ? this.animal.states[0].date : 0
                        return date > lastStateDate
                    },
                    maxValue: maxValue(Math.trunc(Date.now() / 1000) + (60*60))
                },
                price: {
                    integer,
                    minValue: minValue(0)
                }
            },
            dried: {
                date: {
                    required,
                    minValue(date) {
                        let lastStateDate = this.animal != null && this.animal.states[0] !== undefined ? this.animal.states[0].date : 0
                        return date > lastStateDate
                    },
                    maxValue: maxValue(Math.trunc(Date.now() / 1000) + (60*60))
                }
            },
            hot: {
                date: {
                    required,
                    minValue(date) {
                        let lastStateDate = this.animal != null && this.animal.states[0] !== undefined ? this.animal.states[0].date : 0
                        return date > lastStateDate
                    },
                    maxValue: maxValue(Math.trunc(Date.now() / 1000) + (60*60))
                }
            },
            insemination: {
                date: {
                    required,
                    minValue(date) {
                        let lastStateDate = this.animal != null && this.animal.states[0] !== undefined ? this.animal.states[0].date : 0
                        return date > lastStateDate
                    },
                    maxValue: maxValue(Math.trunc(Date.now() / 1000) + (60*60))
                }
            },
            ultrasound: {
                date: {
                    required,
                    minValue(date) {
                        let lastStateDate = this.animal != null && this.animal.states[0] !== undefined ? this.animal.states[0].date : 0
                        return date > lastStateDate
                    },
                    maxValue: maxValue(Math.trunc(Date.now() / 1000) + (60*60))
                }
            }
        }
    },
    methods: {
        ...mapActions(['createState']),
        close() {
            this.$parent.showFecondityForm = false
            this.$parent.action = null
            this.$parent.selectedAnimal = null
        },
        submit() {
            if (this.isFormValid()) {
                this.createState([this.animal.id, this.action, this.state[this.action]])
                this.close()
            }
        },
        setCalvingResult(r) {
            if (this.typeList.indexOf(r) > -1) {
                this.state.calving.type = r
                this.state.calving.abortion = null
            } else if (this.abortionType.indexOf(r) > -1) {
                this.state.calving.abortion = r
                this.state.calving.type = null
            }
        },
        isFormValid() {
            if (this.action.toString() === 'calving') {
                return this.isCalvingFormValid
            } else if (this.action.toString() === 'cull') {
                return this.isCullFormValid
            } else if (this.action.toString() === 'dried') {
                return this.isDriedFormValid
            } else if (this.action.toString() === 'hot') {
                return this.isHotFormValid
            } else if (this.action.toString() === 'insemination') {
                return this.isInseminationFormValid
            } else if (this.action.toString() === 'ultrasound') {
                return this.isUltrasoundFormValid
            }
        }
    }
}
</script>

<style lang="sass">
    @import '../../sass/mixin/color'
    @import '../../sass/mixin/flex'

    #fecondity-modal
        .modal-container
            .modal-header
                background-color: $dd-light-orange
                color: white
            .modal-body
                form
                    input, input:focus, input:valid, .multiselect
                        border-left: 8px solid $dd-light-orange
                    .select
                        @include flex-center
                        .form-select
                            width: 100%
                            height: 40px
                            background: url('/img/br_down.png') 96% no-repeat #fff
                            border-left: 8px solid $dd-light-orange
                            border-bottom: none
                            border-right: none
                            border-top: transparent
                            padding: 0.25em
                            font-size: 16px
                            font-weight: bold
                            -webkit-appearance: none
                            -moz-appearance: none
                            appearance: none
                    .radio-buttons
                        @include flexbox
                        @include flex-wrap(wrap)
                        @include justify-content(flex-start)
                        .radio-button-wrapper
                            @include flex-center
                            padding: 4px 12px
                            margin: 16px 8px 16px 0
                            background-color: $dd-light-orange
                            text-transform: uppercase
                            font-size: 18px
                            color: white
                            cursor: pointer
                            &.unselected
                                background-color: $grey5
                                color: $text-color

</style>
